import React from 'react';

export const Footer: React.FC = React.memo(() => <footer />);
